import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const CircleStyled = styled.div`
    align-items: center;
    background-color: #fad536;
    border-radius: 20px;
    display: flex;
    height: 40px;
    justify-content: center;
    width: 40px;
`;

const BadgeYellowCircleIcon = ({ color = '#000', iconClasses = '' }) => {
    return (
        <CircleStyled className={iconClasses}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path
                        d="M9.66667 4.33333H15.6667V15.6667H1V4.33333H7"
                        stroke={color}
                        strokeMiterlimit="10"
                        strokeLinecap="square"
                    />
                    <path
                        d="M9.66667 5.66667H7V2.33333C7 1.59667 7.59667 1 8.33333 1C9.07 1 9.66667 1.59667 9.66667 2.33333V5.66667Z"
                        stroke={color}
                        strokeMiterlimit="10"
                        strokeLinecap="square"
                    />
                    <path d="M10.3333 9H13" stroke={color} strokeMiterlimit="10" strokeLinecap="square" />
                    <path d="M10.3333 11.6667H13" stroke={color} strokeMiterlimit="10" strokeLinecap="square" />
                    <path
                        d="M3 13C3 11.8953 3.89533 11 5 11H6.33333C7.438 11 8.33333 11.8953 8.33333 13H3Z"
                        fill={color}
                    />
                    <path
                        d="M5.66665 10.3333C6.40303 10.3333 6.99998 9.73638 6.99998 9.00001C6.99998 8.26363 6.40303 7.66667 5.66665 7.66667C4.93027 7.66667 4.33331 8.26363 4.33331 9.00001C4.33331 9.73638 4.93027 10.3333 5.66665 10.3333Z"
                        fill={color}
                    />
                </g>
            </svg>
        </CircleStyled>
    );
};

BadgeYellowCircleIcon.propTypes = {
    color: PropTypes.string,
    iconClasses: PropTypes.string,
};

export default BadgeYellowCircleIcon;
